<script setup>
// design 的 AI Effects 推广条（shell.js:54-65），逐字复刻，替换原通用 upsell。
// 站内链接：AI Effects → /#effects，首页 → /。
// 4 个卡片为线上 CDN 真实效果，随机抽取且每次切页重新随机。
import { computed } from "vue";
import { useStore } from "vuex";
import { useRandomEffects } from "@/composables/useRandomEffects";
import { useAuthModals } from "@/composables/useAuthModals";

const fx = useRandomEffects(4);
const store = useStore();
const router = useRouter();
const { openSignInModal } = useAuthModals();
const isLoggedIn = computed(() => !!store.state.user.token);
function getCredits() {
  if (!isLoggedIn.value) openSignInModal("/my/earn-credits/");
  else router.push("/my/earn-credits/");
}
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="fx-band">
        <div class="fx-band-in">
          <div>
            <div class="eyebrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l1.8 4.4L18 9l-4.2 1.6L12 15l-1.8-4.4L6 9l4.2-1.6z" /><path d="M18 14l.9 2.1 2.1.9-2.1.9L18 20l-.9-2.1L15 17l2.1-.9z" /></svg>AI Effects
            </div>
            <h2>Don't stop at editing — make it go viral</h2>
            <p>Turn your file into a share-worthy AI Effect — one tap, no prompts.</p>
            <div class="cta-row">
              <a class="btn btn-primary" href="/ai/effects/">Explore AI Effects</a>
              <button type="button" class="btn btn-outline" @click="getCredits">Get 10 free credits</button>
            </div>
          </div>
          <div class="fx-gal">
            <a
              v-for="e in fx"
              :key="e.code"
              class="fx-mini"
              :href="e.href"
            >
              <span class="bg" :style="{ backgroundImage: 'url(' + (e.gif || e.thumb) + ')', backgroundSize: 'cover', backgroundPosition: 'center' }"></span>
              <span class="grain"></span>
              <span class="shade"></span>
              <span class="play"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z" /></svg></span>
              <span class="cap">
                <span class="tag">AI Effect</span>
                <span class="nm">{{ e.title }}</span>
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
